import LightDark from "Components/Common/LightDark";
import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

interface Props {
  received: number;
  autoClosed: number;
}

const LIGHT_COLORS = ["#1DA3C6", "#FF70A5"]; // blue, pink
const DARK_COLORS = ["#1b86a4", "#b45d7f"];

const FeedbackChart: React.FC<Props> = ({ received, autoClosed }) => {
  const isDark = document.documentElement.getAttribute("data-bs-theme") === "dark";
  const palette = isDark ? DARK_COLORS : LIGHT_COLORS;

  const chartData = [
    { name: "Recieved", value: received, color: palette[0] },
    { name: "Auto-closed", value: autoClosed, color: palette[1] },
  ];
  return (
    <div 
      style={{
        backgroundColor: "var(--vz-card-bg, #E8F3EF)",
        borderRadius: 16,
        padding: 16,
        display: "flex",
        flexDirection: "column",
        gap: 12,
        width: 400,
      }}
    >
      <h3
        className="m-0 text-[18px] fw-semibold"
        style={{ color: "var(--vz-card-color, #111827)" }}
      >
      Feedback Breakdown
     </h3>


      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {chartData.map((item) => (
            <div
              key={item.name}
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <span
                style={{
                  width: 12,
                  height: 14,
                  borderRadius: 4,
                  backgroundColor: item.color,
                }}
              />
              <span
                style={{
                  fontSize: 14,
                  color: "var(--vz-card-color, #111827)",
                }}
              >
                {item.name}
              </span>
            </div>
          ))}
        </div>

        <PieChart width={260} height={200}>
          <Pie
            data={chartData}
            cx={140}
            cy={100}
            outerRadius={80}
            dataKey="value"
            labelLine={false}
          >
            {chartData.map((entry) => (
              <Cell
                key={entry.name}
                fill={entry.color}
                stroke="#FFFFFF"
                strokeWidth={1}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </div>
    </div>
  );
};

export default FeedbackChart;
